import { useState } from 'react';

import clsx from 'clsx';

interface Props {
    fallbackLabel: string;
    imageUrl: string;
    imageAlt?: string;
    fullHeight?: boolean;
}

const BoxImage = ({
    fallbackLabel,
    imageUrl,
    imageAlt,
    fullHeight = false,
}: Props): JSX.Element => {
    const [isError, setIsError] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const updateImageUrl = (url: string): string => {
        const baseUrl = url.split('?')[0];
        const newUrl = `${baseUrl}?imwidth=700`;
        return newUrl;
    };

    const imageUrlHigherQuality = updateImageUrl(imageUrl);

    const handleImageError = () => {
        if (imageUrlHigherQuality) {
            setIsError(false); // Reset dell'errore e tenta di caricare l'immagine senza parametri
        } else {
            setIsError(true); // Se non c'è un fallback, segnala l'errore
        }
    };

    return (
        <>
            {!isError && (
                <img
                    className={clsx(fullHeight && 'h-100')}
                    src={imageUrlHigherQuality}
                    alt={imageAlt && 'image'}
                    onLoad={() => setIsLoading(false)}
                    onError={handleImageError}
                />
            )}
            {isError && imageUrl && (
                <img
                    className={clsx(fullHeight && 'h-100')}
                    src={imageUrl} 
                    alt={imageAlt || 'image'}
                    onLoad={() => setIsLoading(false)}
                    onError={() => setIsError(true)}
                />
            )}
            {isError && !imageUrl && (
                <div
                    className={clsx(
                        'fallback secondary-message large dark-grey align-center',
                        fullHeight && 'h-100'
                    )}
                >
                    {fallbackLabel}
                </div>
            )}
        </>
    );
};
export default BoxImage;
